package `fun`.adaptive.adaptive_lib_app.generated.resources

import `fun`.adaptive.resource.string.Strings
import `fun`.adaptive.resource.string.StringStoreResourceSet
import `fun`.adaptive.resource.file.FileResource

val commonMainStringsStringStore0 =
    StringStoreResourceSet(
        name = "strings",
        FileResource("/fun.adaptive.adaptive_lib_app.generated.resources/strings/strings.avs", setOf())
    )

val Strings.accountName
    get() = commonMainStringsStringStore0.get(0)

val Strings.accountSelf
    get() = commonMainStringsStringStore0.get(1)

val Strings.accounts
    get() = commonMainStringsStringStore0.get(2)

val Strings.addAccount
    get() = commonMainStringsStringStore0.get(3)

val Strings.addRole
    get() = commonMainStringsStringStore0.get(4)

val Strings.administration
    get() = commonMainStringsStringStore0.get(5)

val Strings.confirmPassword
    get() = commonMainStringsStringStore0.get(6)

val Strings.context
    get() = commonMainStringsStringStore0.get(7)

val Strings.currentPassword
    get() = commonMainStringsStringStore0.get(8)

val Strings.devTools
    get() = commonMainStringsStringStore0.get(9)

val Strings.editAccount
    get() = commonMainStringsStringStore0.get(10)

val Strings.email
    get() = commonMainStringsStringStore0.get(11)

val Strings.filter
    get() = commonMainStringsStringStore0.get(12)

val Strings.invalidFields
    get() = commonMainStringsStringStore0.get(13)

val Strings.name
    get() = commonMainStringsStringStore0.get(14)

val Strings.newPassword
    get() = commonMainStringsStringStore0.get(15)

val Strings.noTechnicalInfo
    get() = commonMainStringsStringStore0.get(16)

val Strings.password
    get() = commonMainStringsStringStore0.get(17)

val Strings.passwordChange
    get() = commonMainStringsStringStore0.get(18)

val Strings.pwdResetButton
    get() = commonMainStringsStringStore0.get(19)

val Strings.pwdResetSendSuccess
    get() = commonMainStringsStringStore0.get(20)

val Strings.pwdResetSubTitle
    get() = commonMainStringsStringStore0.get(21)

val Strings.pwdResetTitle
    get() = commonMainStringsStringStore0.get(22)

val Strings.roles
    get() = commonMainStringsStringStore0.get(23)

val Strings.save
    get() = commonMainStringsStringStore0.get(24)

val Strings.saveFail
    get() = commonMainStringsStringStore0.get(25)

val Strings.saveSuccess
    get() = commonMainStringsStringStore0.get(26)

val Strings.signInButton
    get() = commonMainStringsStringStore0.get(27)

val Strings.signInForgot
    get() = commonMainStringsStringStore0.get(28)

val Strings.signInRemember
    get() = commonMainStringsStringStore0.get(29)

val Strings.signInSignUp
    get() = commonMainStringsStringStore0.get(30)

val Strings.signInSubTitle
    get() = commonMainStringsStringStore0.get(31)

val Strings.signInSuccess
    get() = commonMainStringsStringStore0.get(32)

val Strings.signInTitle
    get() = commonMainStringsStringStore0.get(33)

val Strings.signUpAgree
    get() = commonMainStringsStringStore0.get(34)

val Strings.signUpButton
    get() = commonMainStringsStringStore0.get(35)

val Strings.signUpFail
    get() = commonMainStringsStringStore0.get(36)

val Strings.signUpSignIn
    get() = commonMainStringsStringStore0.get(37)

val Strings.signUpSubTitle
    get() = commonMainStringsStringStore0.get(38)

val Strings.signUpTitle
    get() = commonMainStringsStringStore0.get(39)

val Strings.singInFail
    get() = commonMainStringsStringStore0.get(40)